import "branding_shared";
import React from 'react';
import {StyleSheetManager, ThemeProvider} from 'styled-components';
import {shouldForwardProp} from 'components';
import {BuildYourOwn} from 'byolayout';
import {Light, Dark, Global, Fonts} from 'branding_can-am-offroad';

const App: React.FC = () => {
  return (
    <React.Fragment>
      <Fonts/>
      <Global/>
      <StyleSheetManager shouldForwardProp={shouldForwardProp}>
        <ThemeProvider theme={{...Light, themes: {main: Light, alt: Dark}}}>
          <BuildYourOwn/>
        </ThemeProvider>
      </StyleSheetManager>
    </React.Fragment>
  );
}

export default App;
